"use client";

import { BaseSpinner } from "@faire/slate/private/loading-spinner/BaseSpinner";
import {
  getSpinnerSize,
  getSpinnerStrokeWidth,
} from "@faire/slate/private/loading-spinner/utils";
import { useStrictLocalization } from "@faire/web/common/localization";
import React from "react";

export const ButtonLoading = () => {
  const size = getSpinnerSize("small");
  const strokeWidth = getSpinnerStrokeWidth("small");
  const { strictLocalize } = useStrictLocalization();
  return (
    <span className="absolute top-0 right-0 bottom-0 left-0 flex items-center justify-center rounded-[inherit] text-inherit">
      <BaseSpinner
        aria-label={strictLocalize({
          defaultMessage: "Loading",
          description: {
            text: "Message for screen readers when buttons just show a loading spinner with no text",
          },
        })}
        color="currentColor"
        role="status"
        size={size}
        strokeWidth={strokeWidth}
      />
    </span>
  );
};
